'use client';

import type { FC } from 'react';
import { ScreenContent, ScreenFixedTop, ScreenTabBar } from '../../screen';
import { useLocalTranslation } from '../../hooks/useLocalTranslation';
import { useIsAuthed } from '../../hooks/useIsAuthed';
import { useCapability } from '../../runtime/useCapability';
import { useOpenSupportChat } from '../../stores/supportChatStore';
import { Button } from '../../components/ui/Button';
import { InfoCard } from '../../components/ui/InfoCard';
import { InfoRow } from '../../components/ui/InfoRow';
import translations from './SupportScreen.translations';

const EMAIL = 'support@cs-shot.uz';
const TELEGRAM = 'cs_shot_support';

export const SupportScreen: FC = () => {
  const { t } = useLocalTranslation(translations);
  const isAuthed = useIsAuthed();
  const hasChat = useCapability('supportChatWidget');
  const openChat = useOpenSupportChat();

  return (
    <>
      <ScreenFixedTop title={t('title')} />
      <ScreenTabBar />
      <ScreenContent>
        <div className="mx-auto flex max-w-2xl flex-col gap-4 p-4 pb-8">
          {hasChat && isAuthed && (
            <InfoCard className="flex flex-col gap-2">
              <span className="text-sm text-white">{t('chatTitle')}</span>
              <span className="text-xs text-label-tertiary">{t('chatHint')}</span>
              <Button onClick={openChat} className="mt-1 self-start">
                {t('chatAction')}
              </Button>
            </InfoCard>
          )}
          <InfoCard>
            {/* WHY: адреса латиницей — на фарси без ltr «@» ника уезжала в конец */}
            <div className="flex flex-col">
              <InfoRow label={t('labelEmail')}>
                <a dir="ltr" className="text-accent-blue hover:underline" href={`mailto:${EMAIL}`}>
                  {EMAIL}
                </a>
              </InfoRow>
              <InfoRow label={t('labelTelegram')}>
                <a
                  dir="ltr"
                  className="text-accent-blue hover:underline"
                  href={`https://t.me/${TELEGRAM}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @{TELEGRAM}
                </a>
              </InfoRow>
              <InfoRow label={t('labelHours')}>{t('valueHours')}</InfoRow>
              <InfoRow label={t('labelResponse')}>{t('valueResponse')}</InfoRow>
            </div>
          </InfoCard>
        </div>
      </ScreenContent>
    </>
  );
};
